import {Injectable} from '@angular/core';
import {
  downloadXlsxBuffer,
  jsonRowsToAoA,
  JsonToSheetOpts,
  writeXlsxBuffer,
} from '../_utils/excel-workbook.util';

@Injectable({
  providedIn: 'root'
})
export class JSONExportService {

  constructor() {
  }

  exportToExcel(fileName: string, data: any[], headersRemap: JSONExportHeader[], opts?: JsonToSheetOpts, sheetName?: string): void {
    if (headersRemap) {
      data = this.remapJSON(data, headersRemap);
    }
    const sheet = sheetName || 'data';
    this.applyHeaderFormats(data, headersRemap);
    writeXlsxBuffer([{ name: sheet, aoa: jsonRowsToAoA(data, opts) }]).then((buffer) => {
      downloadXlsxBuffer(buffer, fileName + '.xlsx');
    });
  }

  /**
   * ExcelJS writes Shared String Table cells by default (t="s"), which is the
   * behaviour previously requested via SheetJS `bookSST: true` for consumers
   * such as Apache POI that reject inline strings.
   *
   * Behaviour is otherwise identical to {@link exportToExcel}.
   */
  exportToExcelSharedStrings(fileName: string, data: any[], headersRemap: JSONExportHeader[], opts?: JsonToSheetOpts, sheetName?: string): void {
    this.exportToExcel(fileName, data, headersRemap, opts, sheetName);
  }

  numberWithCommas(x: string) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


  exportToExcelCountByBusiness(fileName: string, data: any[], headersRemap: JSONExportHeader[][], opts?: JsonToSheetOpts): void {

    headersRemap.forEach((value, index) => {
        data[index] = this.remapJSON(data[index], headersRemap[index]);
        console.log(data[index]); // 0, 1, 2
        console.log(value); // 9, 2, 5
    });

    writeXlsxBuffer([
      { name: 'Current Year', aoa: jsonRowsToAoA(data[0], opts) },
      { name: 'Previous Year', aoa: jsonRowsToAoA(data[1], opts) },
      { name: 'Count By Business', aoa: jsonRowsToAoA(data[2], opts) },
    ]).then((buffer) => {
      downloadXlsxBuffer(buffer, fileName + '.xlsx');
    });
  }

  private applyHeaderFormats(data: any[], headersRemap: JSONExportHeader[]): void {
    if (!headersRemap) {
      return;
    }
    for (let row = 0; row < data.length; row++) {
      for (let col = 0; col < headersRemap.length; col++) {
        if (headersRemap[col].format != undefined && headersRemap[col].format == 'number') {
          if (data[row][headersRemap[col].header] != undefined) {
            data[row][headersRemap[col].header] = this.numberWithCommas(data[row][headersRemap[col].header]);
          }
        } else if (headersRemap[col].format != undefined && headersRemap[col].format == 'percent') {
          if (data[row][headersRemap[col].header] != undefined) {
            data[row][headersRemap[col].header] += '%';
          }
        }
      }
    }
  }

  private remapJSON(data: any[], headersRemap: JSONExportHeader[]): any[] {
    const result: any[] = [];
    data.forEach((dataRow: any) => {
      const resRow: any = {};
      headersRemap.forEach((h: JSONExportHeader) => {
        resRow[h.header] = dataRow[h.field];
      });
      result.push(resRow);
    });
    return result;
  }

}

export interface JSONExportHeader {
  header: string;
  field: string;
  format?: string;
}
